import { ChatType } from "../enums/ChatType";

export const DOMAIN_SPECIFIC_CHAT_TYPES: ChatType[] = [
  ChatType.ESG,
  ChatType.HRDocuments,
  ChatType.QEC,
  ChatType.quilt,
];
